import { ref } from '@vue/composition-api'
import drawsApi from '@/services/api/draws'

export default function useDrawsPublicDashboard() {
  const drafts = ref([])
  const loading = ref(false)

  async function fetchDashboard() {
    loading.value = true
    try {
      const res = await drawsApi.getPublicDashboard()
      const data = res.data.data
      drafts.value = data.drafts != null ? data.drafts : []
    } catch (_) {
      drafts.value = []
    } finally {
      loading.value = false
    }
  }

  return { drafts, loading, fetchDashboard }
}



// WEBPACK FOOTER //
// ./src/composables/draws/useDrawsPublicDashboard.js